import { ref } from "vue";

/** 店舗登録画面のUI状態を扱う composable。 */
export const useShopRegisterUiState = () => {
  const overlay = ref<boolean>(false); //完了ボタン押下時のLoading
  const errdialog = ref<boolean>(false); //エラーダイアログ
  const errMessage = ref<string>(""); //エラーメッセージ
  const updateMode = ref<boolean>(false);
  const dssFlg = ref<boolean>(false); //DSS連携フラグ
  // 店舗作成確認ダイアログ表示フラグ
  const displayConfirmDialog = ref<boolean>(false);
  // 店舗作成完了ダイアログ表示フラグ（元の class フィールド `displayCompletedDialog = false;` 相当）
  const displayCompletedDialog = ref<boolean>(false);
  const areaDialog = ref<boolean>(false);
  const validateOnMount = ref(false);

  /** エラーダイアログを表示してフォーカスを外す。 */
  const errdialogRefSetter = (val: boolean, msg: string): void => {
    errdialog.value = val;
    errMessage.value = msg;
    (document.activeElement as HTMLElement | null)?.blur();
  };

  return {
    overlay,
    errdialog,
    errMessage,
    updateMode,
    dssFlg,
    displayConfirmDialog,
    displayCompletedDialog,
    areaDialog,
    validateOnMount,
    errdialogRefSetter,
  };
};
